import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { API_BASE_URL } from './api-base';

@Injectable({ providedIn: 'root' })
export class ControlchatSocketService {
  private socket: Socket | null = null;

  connect(tenantId: number, userId: number) {
    if (this.socket) {
      return this.socket;
    }
    this.socket = io(API_BASE_URL, {
      auth: {
        tenant_id: tenantId,
        user_id: userId
      }
    });
    return this.socket;
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  joinConversations(conversationIds: number[]) {
    this.socket?.emit('join:conversations', conversationIds);
  }

  leaveConversation(conversationId: number) {
    this.socket?.emit('leave:conversation', conversationId);
  }

  on(event: string, handler: (...args: any[]) => void) {
    this.socket?.on(event, handler);
  }

  off(event: string, handler?: (...args: any[]) => void) {
    if (!this.socket) {
      return;
    }
    if (handler) {
      this.socket.off(event, handler);
      return;
    }
    this.socket.off(event);
  }
}
